import { autoinject, bindable } from 'aurelia-framework';
import { fireEventOn } from 'app/shared/lib/fire-events';
import { CustomElementBase } from 'app/shared/elements/custom-element-base';
import { EssDropdownCustomElement } from 'app/shared/elements/ess-dropdown';
import { guid } from 'app/shared/lib/guid';

export interface INotifications {
    close(): void;
}

@autoinject()
export class EssNotificationsCustomElement extends CustomElementBase implements INotifications {

    @bindable() public text: string | null = null;
    @bindable() public count: number = 0;
    @bindable() public maxCount: number = Number.POSITIVE_INFINITY;
    @bindable() public pulse: boolean = false;
    public tooltip: string | null = null;

    protected id: guid = guid();

    // refs
    protected $notificationsDropdown!: EssDropdownCustomElement;

    protected countChanged(): void {
        this.tooltip = this.count === 1 ? 'ui:navigation.tooltips.notification.$' : 'ui:navigation.tooltips.notification.$_plural';
    }

    protected openDropdown(): void {
        this.$notificationsDropdown?.toggle();
        fireEventOn(this.element, 'notifications-open');
    }

    public close() {
        this.$notificationsDropdown?.close();
    }

}
